import React from 'react';
import {AuthProvider as OidcAuthProvider} from 'react-oidc-context';
import userManager from './userManager';
import SessionIdentityGuard from './SessionIdentityGuard';
import {clearLegacyAuthState, syncProfileFromToken} from './sessionSync';

const onSigninCallback = (user) => {
  // Remove OIDC query params (?code=...&state=...) from URL after login
  window.history.replaceState({}, document.title, window.location.pathname);

  // Clear any stale legacy keys from a prior session BEFORE writing the
  // new ones — prevents the "client sending stale token" failure pattern.
  clearLegacyAuthState();

  // Sync OIDC claims into localStorage so class components (sidebar, AuthRoute)
  // can read role/orgId without hooks. Writing this key is also what tells the
  // other tabs a login just completed (see SessionIdentityGuard).
  syncProfileFromToken(user?.access_token);
};

// One UserManager for the whole app, passed in explicitly rather than letting
// react-oidc-context build a second one from the settings. The API layer's
// 401 handler (src/api/index.js) and the cross-tab sync both drive this same
// instance, so a silent refresh or an adopted token now updates the React
// tree instead of only the storage slot underneath it.
const AuthProvider = ({children}) => {
  return (
    <OidcAuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
      <SessionIdentityGuard />
      {children}
    </OidcAuthProvider>
  );
};

export default AuthProvider;
